import React from "react";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { getFormSummary } from "../../utils/getFormSummary";
import { Col } from "reactstrap";

const Schema = {
  heights: {
    header1: "auto",
  },
  classes: {},
  minDataRowsCount: 1,
  columns: [
    {
      title: "Lamp Nomenclature",
      colSpan: 1,
      rowSpan: 1,
      className: "tbl-text-normal",
      accessor: "desc",
      // dataClassName: "text-left pd-left-5px d-block",
    },
    {
      title: "AC Reading (V)",
      colSpan: 1,
      rowSpan: 1,
      className: "tbl-text-normal",
      accessor: "acread",
      // dataClassName: "text-right pd-right-10px d-block",
    },
    {
      title: "DC Reading (V)",
      colSpan: 1,
      rowSpan: 1,
      className: "tbl-text-normal",
      accessor: "dcread",
      // dataClassName: "text-right pd-right-10px d-block",
    },
    {
      title: "Condition",
      colSpan: 1,
      rowSpan: 1,
      className: "tbl-text-normal",
      accessor: "test",
      // dataClassName: "text-right pd-right-10px d-block",
    },
    {
      title: "Comments",
      colSpan: 3,
      rowSpan: 1,
      className: "tbl-text-normal",
      accessor: ["com"],
    },
  ],
};
const AnnualLampVoltageTest = (monthData) => {
  let formData = (monthData && monthData.test) || [];
  let summary = getFormSummary({ form: formData.formData });
  if (!summary) return;
  return (
    <div style={{ paddingInline: "15px" }}>
      <strong>SSIT-1001(e)1 – Annual Lamp Voltage Test</strong>
      <table className="table-bordered annualLampVoltage-table">
        <ReportTableSectionRenderer section={Schema} rowsData={(summary && summary.tblBatt) || []} />
      </table>
    </div>
  );
};

export default AnnualLampVoltageTest;



// WEBPACK FOOTER //
// ./src/components/Reports/sims/ontario/annualLampVoltageTest.jsx